import {
  ILoginRequestParameter,
  IOmniLoginRequestParameter,
  IPostLoginBody,
  IPostLoginResponse,
  IPostOmniLoginResponse,
  IPostTokenBody,
} from '../interfaces/login.interface';
import { IGetServiceResponse } from '../interfaces/service.interface';
import { IGetUserResponse } from '../interfaces/user.interface';
import { get, post } from '../utils/fetch';
import { MODE_AUTH_API_ERROR } from '../defines/mode';

export const AuthApi = {
  devLogin: async (
    serviceId: number,
    serviceAttribute: number,
    token: string,
  ): Promise<string> => {
    const url = '/api/auth/login';
    const body: IPostLoginBody = {
      services: `${serviceId}&${serviceAttribute}`,
      token,
    };
    console.log('sending request', { url, body });
    const res: IPostLoginResponse = await post(url, body, 'postLogin');
    return res.access_token;
  },

  getOmniAuthEndpointPath: async (postedParam: ILoginRequestParameter) => {
    const searchParams = new URLSearchParams(window.location.search);
    // it works dev-login only
    if (searchParams.get('mode') === MODE_AUTH_API_ERROR) {
      throw new Error();
    }

    const url = `/api/auth/omni-auth-endpoint-path`;
    return await post(url, postedParam, 'getOmniAuthEndpointPath');
  },

  omniLogin: async (
    postedParam: IOmniLoginRequestParameter,
  ): Promise<string> => {
    // omni-login is always for RAKUTEN MEMBER=104
    const url = `/api/auth/omni-login/${postedParam.serviceId}/104`;
    const res: IPostOmniLoginResponse = await post(
      url,
      postedParam,
      'postOmniLogin',
    );
    return res.access_token;
  },

  getUser: async (): Promise<IGetUserResponse> => {
    const searchParams = new URLSearchParams(window.location.search);
    // it works dev-login only
    if (searchParams.get('mode') === MODE_AUTH_API_ERROR) {
      throw new Error();
    }

    const url = '/api/auth/user';
    return await get(url, undefined, 'getUser');
  },

  getService: async (): Promise<IGetServiceResponse> => {
    const url = '/api/auth/service';
    return await get(url, undefined, 'getService');
  },

  postToken: async (
    serviceId: number,
    serviceAttribute: number,
    body: IPostTokenBody,
  ): Promise<string> => {
    const url = `/api/auth/token/${serviceId}/${serviceAttribute}`;
    return await post(url, body, 'postToken');
  },
};
